import {
  FriendlyCaptchaSDK,
} from "@friendlycaptcha/sdk";
import {forwardRef, useEffect, useImperativeHandle, useRef} from "react";
import i18n from "../../../../i18n";

const sdk = new FriendlyCaptchaSDK({
  apiEndpoint: "eu", // Set this to "eu" if you're using the EU endpoint.
  disableEvalPatching: false, // Set this to true if your React application uses eval in dev mode which is common in many frameworks.
});
const FriendlyCaptcha = forwardRef((props, ref) => {
  const captchaRef = useRef(null);
  const widgetHandleRef = useRef(null);
  const currentLang = i18n.language === 'gr' || i18n.language === 'el' ? 'el' : 'en';

  useEffect(() => {
    if (captchaRef.current) {
      const widgetHandle = sdk.createWidget({
        element: captchaRef.current,
        sitekey: "FCMN61J37ADRUV9F",
        startMode: 'auto',
        language: currentLang
      });
      widgetHandleRef.current = widgetHandle;
      if (props.onSuccess) {
        captchaRef.current.addEventListener("frc:widget.complete", (e) => {
          props.onSuccess(e.detail.response);
        });
      }

      if (props.onFailure) {
        captchaRef.current.addEventListener("frc:widget.error", (e) => {
          props.onFailure(e.detail.error);
        });
      }

      if (props.onExpire) {
        captchaRef.current.addEventListener("frc:widget.expire", () => {
          props.onExpire();
        });
      }

      return () => {
        widgetHandle?.destroy();
      }
    }
  }, [currentLang]);

  useImperativeHandle(ref, () => ({
    reset: () => {
      widgetHandleRef.current?.reset();
    },
    start: () => {
      widgetHandleRef.current?.start();
    },
  }));


  return <div style={props.style} ref={captchaRef} className="frc-captcha" />;
});

export default FriendlyCaptcha;
